import { AlertTriangle, DoorOpen } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Modal preventivo: caja cerrada + Valet con costo (presentacional puro).
export const CajaWarningModal = ({ warnOpen, setWarnOpen, irAbrirCaja }) => (
  <Dialog open={warnOpen} onOpenChange={setWarnOpen}>
    <DialogContent className="rounded-none border-[#F59E0B] bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-caja-warning">
      <DialogHeader>
        <div className="h-12 w-12 bg-[#F59E0B]/15 border border-[#F59E0B]/40 flex items-center justify-center mb-2">
          <AlertTriangle className="h-6 w-6 text-[#F59E0B]" />
        </div>
        <DialogTitle className="font-display font-black text-white text-xl">Turno no iniciado</DialogTitle>
        <DialogDescription className="text-white/70 text-sm leading-relaxed">
          Para recibir vehículos de Valet Parking con costo, primero debes abrir turno.
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-2 pt-2">
        <button onClick={irAbrirCaja} data-testid="valet-abrir-caja-btn"
          className="btn-hard w-full h-12 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-bold uppercase tracking-wider flex items-center justify-center gap-2">
          <DoorOpen className="h-5 w-5" /> Abrir Turno
        </button>
        <button onClick={() => setWarnOpen(false)} data-testid="valet-warning-cancel"
          className="w-full h-10 text-white/50 text-xs font-bold uppercase tracking-wider hover:text-white">
          Cancelar
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CajaWarningModal;
